import React, { useState, FormEvent } from "react";
// import { useNavigate } from "react-router-dom";
// import "./register.css"; // Update the path as necessary
// import apiClient from "../../utils/api";
// import { useAuth } from "../../auth/AuthContext";
import { GoogleLoginButton } from "../Google/GoogleLoginButton";
// import { CodeResponse } from "@react-oauth/google";
import {
  Box,
  Button,
  Container,
  Grid,
  Paper,
  TextField,
  Typography,
} from "@mui/material";

const Register: React.FC = () => {
  // const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  // const [message, setMessage] = useState<string | null>(null);
  // const { login } = useAuth();

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault();

    // try {
    //   await apiClient.registerPost({
    //     registerPostRequest: {
    //       email: email,
    //       password: password,
    //     },
    //   });

    //   const { consent } = await apiClient.consentGet();

    //   navigate("/chat");
    //   login({ username: email, consent: consent ?? false });
    // } catch (error: any) {
    //   if (error.response && error.response.body) {
    //     const data = await new Response(error.response.body).json();
    //     const { message } = data;
    //     setMessage(message);
    //   } else {
    //     setMessage("An error occurred. Please try again later.");
    //   }
    // }
  };

  return (
    <Grid container justifyContent="center" alignItems="center" height="100vh">
      <Grid item xs>
        <Container maxWidth="xs" fixed>
          <Paper elevation={24}>
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              direction="column"
              rowSpacing={2}
              padding={2}
            >
              <Grid item>
                <Typography variant="h4">Create an Account.</Typography>
              </Grid>
              {!process.env.REACT_APP_DISABLE_PASSWORD_LOGIN && (
                <Grid
                  item
                  container
                  justifyContent="center"
                  alignItems="center"
                  columnSpacing={1}
                >
                  <Box component="form" onSubmit={handleSubmit}>
                    <TextField
                      id="email"
                      name="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      label="Email"
                      fullWidth
                      helperText="Please enter an imaginary username."
                    />
                    <TextField
                      id="password"
                      name="password"
                      type="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      label="Password"
                      fullWidth
                      helperText="Please enter your password."
                    />
                    <Button
                      fullWidth
                      variant="contained"
                      type="submit"
                      value="Register"
                    >
                      Register
                    </Button>
                  </Box>
                  {/* {message && <div className="error-message">{message}</div>} */}
                </Grid>
              )}
               <Grid item>
                <GoogleLoginButton mode="register"/>
              </Grid>
            </Grid>
          </Paper>
        </Container>
      </Grid>
    </Grid>
  );
};

export default Register;
